<template>
  <div>
    <div class="d-flex justify-space-between align-center mb-4">
      <h2 class="primary--text">Usuarios</h2>
      <v-btn v-if="isAdmin" color="primary" depressed @click="$emit('changeComponent', 'UserNew')">
        <v-icon left>mdi-plus</v-icon> NUEVO USUARIO
      </v-btn>
    </div>

    <users-table-head class="mt-3 mb-3"></users-table-head>

    <div>
      <v-text-field
        v-model="search"
        placeholder="Buscar usuarios"
        color="primary"
        background-color="#DDDDE4"
        prepend-inner-icon="mdi-magnify"
        outlined
        hide-details
      ></v-text-field>
    </div>

    <users-table-item
      v-for="user in userFilters"
      :key="user._id"
      :user="user"
      @edit="edit"
      @delete="deleted"
      @changePassword="changePassword"
    ></users-table-item>

    <v-progress-linear v-if="isLoading" indeterminate />

    <p v-if="!isLoading && users.length === 0" class="text-center mt-4">
      No hay usuarios registrados
    </p>

    <!-- Modal eliminar -->
    <modal-delete
      v-if="dialogDelete"
      :dialogDelete="dialogDelete"
      :body="bodyDelete"
      @cancel="dialogDelete = false"
      @delete="deleteUser"
    ></modal-delete>

    <!-- Modal cambiar contraseña -->
    <v-dialog v-model="dialogPassword" persistent max-width="500">
      <v-card class="pa-6">
        <v-card-title class="text-h6 font-weight-bold primary--text mb-4">
          Cambiar contraseña
        </v-card-title>
        <v-card-subtitle class="mb-4">
          Usuario: <strong>{{ selectedUser.username }}</strong>
        </v-card-subtitle>
        <v-form ref="formPassword" v-model="validPassword">
          <v-text-field
            v-model="newPassword"
            label="Nueva contraseña"
            :type="showPassword ? 'text' : 'password'"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword = !showPassword"
            :rules="passwordRules"
            outlined
          ></v-text-field>
        </v-form>
        <v-card-actions class="d-flex justify-end">
          <v-btn color="error" depressed @click="dialogPassword = false">CANCELAR</v-btn>
          <v-btn color="primary" depressed :disabled="!validPassword" :loading="savingPassword" @click="savePassword">
            GUARDAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <v-snackbar v-model="snackbar" :color="snackbarColor" timeout="3000" top>
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>
import Users from "../../domain/Users";

export default {
  name: "UsersTable",
  components: {
    UsersTableHead: () => import("./table/UsersTableHead.vue"),
    UsersTableItem: () => import("./table/UsersTableItem.vue"),
    ModalDelete: () => import("../base/ModalDelete.vue"),
  },
  data: () => ({
    users: [],
    search: "",
    isLoading: true,
    isAdmin: false,
    dialogDelete: false,
    dialogPassword: false,
    selectedUser: {},
    newPassword: "",
    showPassword: false,
    validPassword: false,
    savingPassword: false,
    snackbar: false,
    snackbarText: "",
    snackbarColor: "success",
    bodyDelete: {
      title: "Eliminar usuario",
      question: "¿Estás seguro de que deseas eliminar este usuario?",
      type: "USUARIO",
    },
    passwordRules: [
      (v) => !!v || "La contraseña es requerida",
      (v) => (v && v.length >= 6) || "Mínimo 6 caracteres",
    ],
  }),
  mounted() {
    const { rol } = JSON.parse(localStorage.LCInternet).user;
    this.isAdmin = rol === "admin";
    this.getAll();
  },
  methods: {
    async getAll() {
      try {
        this.isLoading = true;
        this.users = await Users.getAll();
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.warn(error);
      }
    },
    edit(user) {
      this.$emit("edit", user);
    },
    deleted(user) {
      this.selectedUser = user;
      this.dialogDelete = true;
    },
    async deleteUser() {
      try {
        await Users.delete(this.selectedUser._id);
        this.dialogDelete = false;
        this.showSnackbar("Usuario eliminado correctamente", "success");
        await this.getAll();
      } catch (error) {
        console.warn(error);
        this.showSnackbar("Error al eliminar usuario", "error");
      }
    },
    changePassword(user) {
      this.selectedUser = user;
      this.newPassword = "";
      this.dialogPassword = true;
    },
    async savePassword() {
      try {
        this.savingPassword = true;
        await Users.updatePassword(this.selectedUser._id, this.newPassword);
        this.savingPassword = false;
        this.dialogPassword = false;
        this.showSnackbar("Contraseña actualizada correctamente", "success");
      } catch (error) {
        this.savingPassword = false;
        console.warn(error);
        this.showSnackbar("Error al actualizar contraseña", "error");
      }
    },
    showSnackbar(text, color) {
      this.snackbarText = text;
      this.snackbarColor = color;
      this.snackbar = true;
    },
  },
  computed: {
    userFilters() {
      return this.users.filter((user) => {
        return user.username.toUpperCase().includes(this.search.toUpperCase());
      });
    },
  },
};
</script>
